<template>
<div class="overview-data">
  <el-tab v-model="tabOpen">
    <el-tab-item title="Usage">
      <h2>HeadQ Connections</h2>
      <p>Unique users connecting with HeadQ.</p>
      <bar-graph
        :height="200"
        :data="userGraphData"
        :options="graphOptions"
        />

      <el-column>
        <el-column-item style="min-width: auto;">
          <h2 :class="{ pending: count === 0 }">{{count}}</h2>
          <p><b>Total users</b></p>
        </el-column-item>
        <el-column-item style="min-width: auto;">
          <h2 :class="{ pending: count === 0 }">{{dayCount}}</h2>
          <p><b>Active users today</b></p>
        </el-column-item>
        <el-column-item style="min-width: auto;">
          <h2 :class="{ pending: count === 0 }">{{weekCount}}</h2>
          <p><b>Active users this week</b><br>Last week: {{lastWeekCount}}</p>
        </el-column-item>
      </el-column>

      <!-- <h2>HeadQ starts vs. App connections</h2>
      <scatter-plot
        :height="200"
        :data="headQStarts"
        :options="{
          scales: {
            xAxes: [{
              labelString: 'X a',
              ticks: {
              labelString: 'X a',
                max: 20
              }
            }],
            yAxes: [{
              ticks: {
                max: 100
              }
            }]
          },
          legend: {
              display: false
          }
        }"
        /> -->

      <h2>Onboarding duration</h2>
      <p>Data only displaying last 14 days.</p>
      <el-tab>
        <el-tab-item title="distribution">
          <bar-graph
            :height="200"
            :data="onboardingHistogram"
            :options="{
              scales: {
                xAxes: [{
                  barPercentage: 1.3
                }],
                yAxes: [{
                  ticks: {
                    callback: function(value, index, values) {
                      return value + '%';
                    }
                  }
                }]
              }
            }"
            />
        </el-tab-item>
        <el-tab-item title="Over time">
          <scatter-plot
            :height="200"
            :data="onboardingGraphData"
            :options="{
              scales: {
                yAxes: [{
                  ticks: {
                    max: this.maxOnboardingTime,
                    callback: function(value, index, values) {
                      return value + ' min';
                    }
                  },
                  caption: 'min'
                }],
                xAxes: [{
                  type: 'time',
                  time: {
                    unit: 'day'
                  }
                }]
              }
            }"
            />
        </el-tab-item>
        <el-tab-item title="Skip/disable">
          <el-column>
            <el-column-item style="min-width: auto;">
              <h2 :class="{ pending: onboardingQuantity.doShowAgain === 0 }">{{onboardingQuantity.doShowAgain}}</h2>
              <p>Skip</p>
            </el-column-item>
            <el-column-item style="min-width: auto;">
              <h2 :class="{ pending: onboardingQuantity.doNotShowAgain === 0 }">{{onboardingQuantity.doNotShowAgain}}</h2>
              <p>Don't show again</p>
            </el-column-item>
            <el-column-item style="min-width: auto;">
              <h2 :class="{ pending: onboardingQuantity.doNotShowAgain === 0 }">{{Math.round(100*onboardingQuantity.doNotShowAgain/(onboardingQuantity.doNotShowAgain + onboardingQuantity.doShowAgain))}}%</h2>
              <p>Percentage skipping</p>
            </el-column-item>
          </el-column>
        </el-tab-item>
      </el-tab>

      <h2>Registered users</h2>
      <p>Note: If a user deletes the app and downloads it again it will count as a new user.</p>
      <kpi-value
        v-if="techData.total"
        :value="`${Math.round(techData.os.ios / techData.total * 100)}%`"
        label="iOS users"
        />
      <line-diagram
        :height="200"
        :data="userData"
        :options="{
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day'
              }
            }]
          }
        }"
        />

    </el-tab-item>
    <el-tab-item title="Users">
      <div
        v-for="(id) in sortedUserIds"
        :key="id"
        >
        <el-inline :space-between="true">
          <span style="color: #cacaca;" v-if="!users[id].serialNumber"><i>{{id}}</i></span>
          <span v-else>Serial Number: <b>{{users[id].serialNumber}}</b></span>
          <span>
            {{new Date(users[id].latest).toLocaleString()}}
          </span>
        </el-inline>
        <div>
          <span><b>{{users[id].active.length}}</b> app connections</span><br>
          <span><b>{{users[id].onCount[users[id].onCount.length - 1]}}</b> HeadQ starts</span><br>
          <span><b>{{users[id].battery[users[id].battery.length - 1]}}%</b> Battery level</span><br>

          <br><br>

        </div>
      </div>
    </el-tab-item>
  </el-tab>
</div>
</template>
<script>

import BarGraph from './BarGraph.vue'
import ScatterPlot from './ScatterPlot.vue'
import LineDiagram from './LineDiagram.vue'
import KpiValue from './KpiValue.vue'

import dataLog from 'services/dataLog.js'

import logScope from 'log-scope'
const log = logScope('OverviewData')

const countPerWeek = timestamps => {
  // timestamps = []
  const weekMap = {}
  const getWeek = date => {
    const onejan = new Date(date.getFullYear(), 0, 1)
    return Math.ceil((((date - onejan) / 86400000) + onejan.getDay() - 1) / 7)
  }

  timestamps.forEach(p => {
    const t = p.timestamp
    const w = getWeek(new Date(t))

    if (!weekMap[w]) {
      weekMap[w] = {}
    }

    if (!weekMap[w][p.userId]) {
      weekMap[w][p.userId] = true
    }
  })

  Object.entries(weekMap)
    .forEach(([weekNumber, userIds]) => {
      weekMap[weekNumber] = Object.keys(userIds).length
    })

  return weekMap
}
export default {
  components: { BarGraph, ScatterPlot, LineDiagram, KpiValue },
  data () {
    return {
      tabOpen: 0,
      users: {},
      sortedUserIds: [],
      count: 0,
      dayCount: 0,
      weekCount: 0,
      lastWeekCount: 0,
      userGraphData: {
        labels: [],
        datasets: [{
          label: 'Active users',
          backgroundColor: '#f87979',
          data: []
        }]
      },
      graphOptions: {
        scales: {
          yAxes: [{
            ticks: {
              suggestedMin: 0
            },
            stacked: true
          }],
          xAxes: [{
            stacked: true
          }]
        }
      },
      onboardingQuantity: {
        doShowAgain: 0,
        doNotShowAgain: 0
      },
      onboardingGraphData: {},
      onboardingHistogram: {},
      maxOnboardingTime: 3,
      userData: {},
      techData: {
        os: {},
        total: 0
      },
      headQStarts: {}
    }
  },
  watch: {
    tabOpen () {
      localStorage.setItem('rideQOverviewTabOpen', this.tabOpen)
    }
  },
  mounted () {
    let index = localStorage.getItem('rideQOverviewTabOpen')

    if (index) {
      this.tabOpen = Number(index)
    }

    dataLog.getNewConnection()
      .then(this.update)
      .catch(err => {
        log.error('Could not get data', err)
      })

    dataLog.getOnboarding()
      .then(this.updateOnboarding)
      .catch(err => {
        log.error('Could not get onboarding', err)
      })

    dataLog.getUsers()
      .then(this.updateUsers)
      .catch(err => {
        log.error('Could not get users', err)
      })
  },
  methods: {
    sortUsers () {
      this.sortedUserIds = Object.entries(this.users)
        .map(([id, user]) => ({ id, timestamp: user.latest }))
        .sort((a, b) => b.timestamp - a.timestamp)
        .map(({ id }) => id)
    },
    update (dataReports) {
      const allTimestamps = []
      const newConnectionTimestamps = []

      dataReports.forEach(data => {
        const userId = data.userId
        const timestamp = data.timestamp
        const batteryLevel = data.batteryLevel
        const onCount = data.onCount
        const serialNumber = data.serialNumber

        allTimestamps.push({ timestamp, userId })

        if (!this.users[userId]) {
          this.users[userId] = {
            active: [],
            battery: [],
            onCount: [],
            latest: 0
          }

          newConnectionTimestamps.push({ timestamp, userId })
        }

        this.users[userId].serialNumber = serialNumber

        this.users[userId].active.push(timestamp)
        this.users[userId].battery.push(batteryLevel)
        this.users[userId].onCount.push(onCount)

        if (timestamp > this.users[userId].latest) {
          this.users[userId].latest = timestamp
        }
      })

      let now = new Date()
      let month = now.getMonth()
      let year = now.getFullYear()
      let date = now.getDate()
      let dayOfWeek = now.getDay() - 1
      let todayStart = +(new Date(year, month, date))
      let mondayStart = +(new Date(year, month, date - dayOfWeek))
      const timestamps = []

      Object.entries(this.users).forEach(([id, user]) => {
        const timestamp = user.latest
        timestamps.push(timestamp)

        // Today
        if (timestamp > todayStart) {
          this.dayCount++
        }

        // This week
        if (timestamp > mondayStart) {
          this.weekCount++
        }
      })

      this.count = Object.keys(this.users).length

      const perWeek = countPerWeek(allTimestamps)
      const newUsersPerWeek = countPerWeek(newConnectionTimestamps)
      this.userGraphData = {
        labels: [],
        datasets: [{
          label: 'Recurring users',
          backgroundColor: '#4889C6',
          data: []
        }, {
          label: 'New users',
          backgroundColor: '#F87979',
          data: []
        }]
      }
      Object.entries(perWeek).forEach(([weekNumber, quantity]) => {
        quantity -= newUsersPerWeek[weekNumber] || 0

        this.userGraphData.labels.push(`w.${weekNumber}`)
        this.userGraphData.datasets[0].data.push(quantity)
      })
      Object.entries(newUsersPerWeek).forEach(([weekNumber, quantity]) => {
        this.userGraphData.datasets[1].data.push(quantity)
      })

      this.sortUsers()
      log.debug('Users', this.users)

      // HeadQ starts vs app connections
      const headQStarts = {
        datasets: [{
          backgroundColor: 'transparent',
          borderColor: '#4889C6',
          data: []
        }]
      }

      Object.entries(this.users).forEach(([id, { active, onCount }]) => {
        headQStarts.datasets[0].data.push({
          x: active.length,
          y: onCount[onCount.length - 1]
        })
      })

      this.headQStarts = headQStarts

      // Users last week
      this.lastWeekCount = this.userGraphData.datasets[0].data[this.userGraphData.datasets[0].data.length - 2] +
        this.userGraphData.datasets[1].data[this.userGraphData.datasets[0].data.length - 2]
    },
    updateOnboarding (onboardingData) {
      const onboardingStartTime = +(new Date()) - 1000 * 60 * 60 * 24 * 14
      const doShowAgain = []
      const doNotShowAgain = []
      const histogramSteps = 9
      const histogram = {
        labels: [],
        datasets: [{
          label: 'Duration',
          backgroundColor: '#f87979',
          data: []
        }]
      }
      let total = 0

      for (let i = 1; i <= histogramSteps + 1; i++) {
        let label = `${Math.round((i / histogramSteps * this.maxOnboardingTime) * 10) / 10} min`
        if (i === 1) {
          label = '<' + label
        } else if (i === histogramSteps + 1) {
          label = '>' + label
        }

        histogram.labels.push(label)
        histogram.datasets[0].data.push(0)
      }

      Object.entries(onboardingData)
        .filter(([id, { timestamp }]) => timestamp > onboardingStartTime)
        .forEach(([ id, { dontShowAgain, duration, timestamp, userId } ]) => {
          let minutes = duration > this.maxOnboardingTime * 60 ? this.maxOnboardingTime : duration / 60

          if (dontShowAgain) {
            doNotShowAgain.push({
              x: new Date(timestamp),
              y: minutes
            })
          } else {
            doShowAgain.push({
              x: new Date(timestamp),
              y: minutes
            })
          }

          let index = Math.round(minutes / this.maxOnboardingTime * histogramSteps)
          histogram.datasets[0].data[index]++
          total++
        })

      histogram.datasets[0].data = histogram.datasets[0].data.map(x => x / total * 100)

      this.onboardingGraphData = {
        datasets: [
          {
            label: 'Skip',
            backgroundColor: '#4889C6',
            data: doShowAgain
          },
          {
            label: 'Do not show again',
            backgroundColor: '#f87979',
            data: doNotShowAgain
          }
        ]
      }
      this.onboardingHistogram = histogram
      this.onboardingQuantity.doShowAgain = doShowAgain.length
      this.onboardingQuantity.doNotShowAgain = doNotShowAgain.length
    },
    updateUsers (users) {
      const data = {
        os: {
          ios: 0,
          android: 0
        },
        acc: [],
        accios: [],
        total: 0
      }

      users
        .sort((a, b) => a.timestamp - b.timestamp)
        .forEach(({ os, timestamp }) => {
          data.os[os] = !data.os[os] ? 1 : data.os[os] + 1
          data.total++

          let x = new Date(timestamp)
          let y = data.total

          data.acc.push({ x, y })

          if (os === 'ios') {
            data.accios.push({ x, y: data.os.ios })
          }
        })

      this.techData.os = data.os
      this.techData.total = data.total
      this.userData = {
        datasets: [{
          label: 'iOS',
          backgroundColor: '#4889C6',
          steppedLine: true,
          data: data.accios
        }, {
          label: 'Total users',
          backgroundColor: '#F87979',
          steppedLine: true,
          data: data.acc
        }]
      }
    },
    updateStartTrainingSession (sessions) {
      // Count doc reads
      const type = 'trainingSesstions'
      const quantity = Object.keys(sessions).length
      this.$store.commit('logDocumentRead', { type, quantity })

      log.todo('updateStartTrainingSession', sessions)
    }
  }
}
</script>
<style lang="less" scoped>
  .overview-data {
  }
</style>
